import { AuthAction, AuthActionTypes } from './auth.actions';

export const AUTH_FEATURE_KEY = 'auth';

/**
 * Interface for the 'Auth' data used in
 *  - AuthState, and the reducer function
 *
 *  Note: replace if already defined in another module
 */

/* tslint:disable:no-empty-interface */
export interface Entity {}

export interface AuthState {
  list: any; // list of Auth; analogous to a sql normalized table
  selectedId?: string | number; // which Auth record has been selected
  loaded: boolean; // has the Auth list been loaded
  error?: any; // last none error (if any)
  user?: any;
  loading?: boolean;
}

export interface AuthPartialState {
  readonly [AUTH_FEATURE_KEY]: AuthState;
}

export const initialState: AuthState = {
  list: [],
  loaded: false,
  //loading: true,
};

export function reducer(
  state: AuthState = initialState,
  action: AuthAction
): AuthState {
  switch (action.type) {
    case AuthActionTypes.AuthLoaded: {
      state = {
        ...state,
        user: action.payload,
        loaded: false,
      };
      break;
    }
    case AuthActionTypes.AuthLoadError: {
      state = {
        ...state,
        error: action.payload,
        loading: false,
      };
      break;
    }
    case AuthActionTypes.SignIn: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case AuthActionTypes.SignInError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case AuthActionTypes.SignedIn: {
      state = {
        ...state,
        loading: false,
      };
      break;
    }
    case AuthActionTypes.SignUp: {
      state = {
        ...state,
        loading: true,
      };
      break;
    }
    case AuthActionTypes.SignUpError: {
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    }
    case AuthActionTypes.SignedUp: {
      state = {
        ...state,
        loading: false,
      };
      break;
    }
    case AuthActionTypes.LoggedOut: {
      state = {
        ...state,
        loading: false,
      };
      break;
    }
  }

  return state;
}
